import React, { Component } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import {
  Container,
  Row,
  Form,
  Col,
  Offcanvas,
  Button as BSButton,
  Spinner,
} from "react-bootstrap";
import { toast } from "react-toastify";
import configData from "../../config.json";
import { toPrimeColumns } from "../common/ColumnTranslator";

/**
 * PrimeReactTableAdapter - PrimeReact DataTable alternative to ReactDataTableAdapter.
 * Swap by changing widgetTypeId in widget_instances.
 */
export default class PrimeReactTableAdapter extends Component {
  constructor(props) {
    super(props);
    const { config } = props;
    const tableConfig = config.tableConfig || {};

    this.state = {
      show: false,
      isSubmitting: false,
      isEditing: false,
      data: [],
      globalFilter: "",
      loading: true,
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      formValues: {},
      errors: {},
      editId: null,
      first: 0,
      rows: tableConfig.paginationPerPage || 100,
    };

    this.primeColumns = toPrimeColumns(config.columnsConfig || []);
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    const { config } = this.props;
    if (!config.apiEndPoint) return;

    this.setState({ loading: true });
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + config.apiEndPoint, {
      method: config.apiMethod || "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list || [], loading: false });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        console.error("PrimeReactTableAdapter fetch error:", error);
        toast.error("Failed to load data");
        this.setState({ loading: false });
      });
  };

  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      isEditing: false,
      formValues: this.getDefaultFormValues(),
      errors: {},
      editId: null,
    });
  };

  handleOffcanvasClose = () => {
    this.setState({ show: false, isEditing: false, formValues: {}, errors: {}, editId: null });
  };

  getDefaultFormValues = () => {
    const { config } = this.props;
    const formConfig = config.formConfig || {};
    const fields = formConfig.fields || [];
    const defaults = {};
    fields.forEach((f) => { defaults[f.fieldName] = f.defaultValue || ""; });
    return defaults;
  };

  handleEditRow = (row) => {
    const { config } = this.props;
    const formConfig = config.formConfig || {};
    const fields = formConfig.fields || [];
    const tableConfig = config.tableConfig || {};
    const idField = tableConfig.idField || config.sourceTable + "_Id";

    const formValues = {};
    fields.forEach((f) => {
      const readField = f.dataField || f.fieldName;
      formValues[f.fieldName] = row[readField] || "";
    });

    this.setState({ show: true, isEditing: true, formValues, editId: row[idField], errors: {} });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.state.isSubmitting) return;
    this.setState({ isSubmitting: true });
    const { config } = this.props;
    const actionsConfig = config.actionsConfig || {};
    if (!actionsConfig.addEndpoint) return;

    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    Object.entries(this.state.formValues).forEach(([key, value]) => {
      formData.append(key, value);
    });

    fetch(configData.api_url + actionsConfig.addEndpoint, {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") { this.fetchData(); this.handleOffcanvasClose(); }
      })
      .catch(() => toast.error("Failed to save data"));
  
    this.setState({ isSubmitting: false });
};

  handleUpdate = (e) => {
    e.preventDefault();
    const { config } = this.props;
    const actionsConfig = config.actionsConfig || {};
    const tableConfig = config.tableConfig || {};
    const idField = tableConfig.idField || config.sourceTable + "_Id";
    if (!actionsConfig.editEndpoint) return;

    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append(idField, this.state.editId);
    Object.entries(this.state.formValues).forEach(([key, value]) => {
      formData.append(key, value);
    });

    fetch(configData.api_url + actionsConfig.editEndpoint, {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") { this.fetchData(); this.handleOffcanvasClose(); }
      })
      .catch(() => toast.error("Failed to update data"));
  };

  handleDelete = (row) => {
    const { config } = this.props;
    const actionsConfig = config.actionsConfig || {};
    const tableConfig = config.tableConfig || {};
    const idField = tableConfig.idField || config.sourceTable + "_Id";
    if (!actionsConfig.deleteEndpoint) return;
    if (!window.confirm("Are you sure you want to delete this record?")) return;

    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append(idField, row[idField]);

    fetch(configData.api_url + actionsConfig.deleteEndpoint, {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") this.fetchData();
      })
      .catch(() => toast.error("Failed to delete data"));
  };

  handleFieldChange = (fieldName, value) => {
    this.setState((prev) => ({
      formValues: { ...prev.formValues, [fieldName]: value },
    }));
  };

  showToast = (msg, type) => {
    switch (type) {
      case "success": toast.success(msg); break;
      case "error": toast.error(msg); break;
      case "warning": toast.warn(msg); break;
      default: toast.info(msg);
    }
  };

  renderFormFields = () => {
    const { config } = this.props;
    const formConfig = config.formConfig || {};
    const fields = formConfig.fields || [];

    return fields.map((field) => (
      <Row key={field.fieldName} className="mb-2">
        <Col lg="4" md="4">
          <Form.Label style={{ paddingTop: "8px" }}>{field.displayName || field.fieldName}</Form.Label>
        </Col>
        <Col lg="8" md="8">
          <Form.Control
            type={(field.inputType || "text").toLowerCase()}
            value={this.state.formValues[field.fieldName] || ""}
            onChange={(e) => this.handleFieldChange(field.fieldName, e.target.value)}
            placeholder={`Enter ${field.displayName || field.fieldName}`}
            required={field.required}
          />
        </Col>
      </Row>
    ));
  };

  actionBodyTemplate = (rowData) => {
    const actionsConfig = this.props.config.actionsConfig || {};
    return (
      <div>
        {actionsConfig.canEdit && (
          <Button icon="pi pi-pencil" className="p-button-sm p-button-rounded p-button-text" onClick={() => this.handleEditRow(rowData)} />
        )}
        {actionsConfig.canDelete && (
          <Button icon="pi pi-trash" className="p-button-sm p-button-rounded p-button-text p-button-danger" onClick={() => this.handleDelete(rowData)} />
        )}
      </div>
    );
  };

  render() {
    const { config } = this.props;
    const actionsConfig = config.actionsConfig || {};
    const tableConfig = config.tableConfig || {};

    return (
      <div>
        <Row className="mb-2">
          <Col>
            {tableConfig.searchable !== false && (
              <span className="p-input-icon-left">
                <InputText
                  placeholder="Search..."
                  onInput={(e) => this.setState({ globalFilter: e.target.value })}
                  style={{ marginBottom: "10px" }}
                />
              </span>
            )}
          </Col>
          <Col className="d-flex justify-content-end">
            {actionsConfig.canAdd && (
              <BSButton variant="primary" className="bi bi-plus" onClick={this.handleOffcanvasShow}>
                New
              </BSButton>
            )}
          </Col>
        </Row>

        <DataTable
          value={this.state.data}
          paginator
          rows={this.state.rows}
          globalFilter={this.state.globalFilter}
          loading={this.state.loading}
          stripedRows
          responsiveLayout="scroll"
          emptyMessage="No records found."
          first={this.state.first}
          onPage={(e) => this.setState({ first: e.first, rows: e.rows })}
        >
          {this.primeColumns.map((col) => (
            <Column
              key={col.field}
              field={col.field}
              header={col.header}
              sortable={col.sortable}
              body={col.body}
              style={col.style}
            />
          ))}
          {(actionsConfig.canEdit || actionsConfig.canDelete) && (
            <Column header="Actions" body={this.actionBodyTemplate} style={{ width: "120px" }} />
          )}
        </DataTable>

        {/* Add Offcanvas */}
        <Offcanvas
          show={this.state.show && !this.state.isEditing}
          onHide={this.handleOffcanvasClose}
          style={{ width: "500px" }}
          placement="end"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Add {config.instanceName || "Record"}</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Container>
              <Form>{this.renderFormFields()}</Form>
              <Row className="mt-3">
                <Col className="d-flex justify-content-end">
                  <BSButton variant="success" onClick={this.handleSubmit} disabled={this.state.isSubmitting}>
                        {this.state.isSubmitting ? (<><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />Saving...</>) : "Save"}
                      </BSButton>
                </Col>
              </Row>
            </Container>
          </Offcanvas.Body>
        </Offcanvas>

        {/* Edit Offcanvas */}
        {this.state.isEditing && (
          <Offcanvas
            show={this.state.isEditing}
            onHide={this.handleOffcanvasClose}
            style={{ width: "500px" }}
            placement="end"
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>Edit {config.instanceName || "Record"}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Container>
                <Form>{this.renderFormFields()}</Form>
                <Row className="mt-3">
                  <Col className="d-flex justify-content-end">
                    <BSButton variant="success" onClick={this.handleUpdate}>Update</BSButton>
                  </Col>
                </Row>
              </Container>
            </Offcanvas.Body>
          </Offcanvas>
        )}
      </div>
    );
  }
}
